import React from 'react'
import { Row, Flex1 } from '@appearance/styled'
import DatePicker from '@components/Form/DatePicker'
export default ({ fromDate, toDate, changeFromDate, changeToDate }) => {
    return (
        <Row>
            <DatePicker
                // disabledDays={{
                //     before: new Date(),
                //     after: new Date(),
                // }}
                label={'מתאריך'}
                date={fromDate}
                maxDate={new Date(new Date().setDate(new Date().getDate() - 2))}
                onChange={(date) => changeFromDate(date)}
                from
            />
            <DatePicker
                // disabledDays={{
                //     before: new Date(),
                //     after: new Date(),
                // }}
                // disabledDays={{ after: today }}
                label={'עד תאריך'}
                date={toDate}
                // maxDate={toDate}
                // maxDate={Moment.moment().subtract(1, 'days')}
                onChange={(date) => changeToDate(date)}
            />
            <Flex1 />
        </Row>
    )
}
